<template>
  <footer class="section-footer">
    <div class="section-footer__loterie-vert footer-common">
      <div class="section-footer__title">
        Loterie Vert
      </div>
      <div class="section-footer__menu">
        <a @click="$router.push('/')">Loto 7/28</a>
      </div>
      <div class="section-footer__menu">
        <a @click="$router.push('/how-to-play')">How to Play</a>
      </div>
    </div>
    <div class="section-footer__info footer-common">
      <div class="section-footer__title">
        Info
      </div>
      <div class="section-footer__menu">
        <a @click="$router.push('/results')">Results</a>
      </div>
      <div class="section-footer__menu">
        <a @click="$router.push('/faqs')">FAQ's</a>
      </div>
    </div>
    <div class="section-footer__social footer-common">
      <div class="icon">
        <img src="@/assets/images/footer/facebook.svg"/>
      </div>
      <div class="icon">
        <img src="@/assets/images/footer/twitter.svg"/>
      </div>
      <div class="icon">
        <img src="@/assets/images/footer/pinterest.svg"/>
      </div>
      <div class="icon">
        <img src="@/assets/images/footer/google-plus.svg"/>
      </div>
    </div>
    <div class="section-footer__copyright footer-common">
      <div class="icon-18">
        <img src="@/assets/images/footer/18plus.png"/>
      </div>
      <div class="copyright">
        © 2021 Loterie Vert
      </div>
      <div class="copyright-des">
        Age restriction 18 +years | Play Responsibly | T&C applies.
      </div>
    </div>
  </footer>
</template>
<script>
export default {}
</script>
